import { render, staticRenderFns } from "./Cartilla.vue?vue&type=template&id=3d60fd34&"
import script from "./Cartilla.vue?vue&type=script&lang=js&"
export * from "./Cartilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports